"use client";

/**
 * Presenter-chrome subcomponent: pause/resume + reset + rewind grid.
 * Four buttons in a 2×2 layout: pause/resume, reset, ⤺ act, ⤺ screen.
 */
export function RewindControls({
  paused,
  onTogglePause,
  onReset,
  onRewindAct,
  onRewindScreen,
}: {
  paused: boolean;
  onTogglePause: () => void;
  onReset: () => void;
  onRewindAct: () => void;
  onRewindScreen: () => void;
}) {
  return (
    <div className="mt-3 grid grid-cols-2 gap-2">
      <button
        onClick={onTogglePause}
        className="rounded border border-orbitra-muted/30 py-1 text-orbitra-paper hover:border-state-verified/40"
      >
        {paused ? "▶ resume" : "⏸ pause"}
      </button>
      <button
        onClick={onReset}
        className="rounded border border-orbitra-muted/30 py-1 text-orbitra-paper hover:border-state-verified/40"
      >
        ↺ reset
      </button>
      <button
        onClick={onRewindAct}
        className="rounded border border-orbitra-muted/30 py-1 text-orbitra-paper hover:border-state-verified/40"
      >
        ⤺ act
      </button>
      <button
        onClick={onRewindScreen}
        className="rounded border border-orbitra-muted/30 py-1 text-orbitra-paper hover:border-state-verified/40"
      >
        ⤺ screen
      </button>
    </div>
  );
}
